import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    card: {
      padding: 10,
      display: 'flex'
    },
    itemListDetail: {
      display: 'flex',
      color: 'gray',
      flexDirection: 'row',
      alignItems: 'center'
    },
    image: {
      width: 300
    },
    root: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      borderLeft: `solid 4px ${theme.palette?.primary.main}`,
      padding: '20px 10px 0',
      minHeight: 150,
      width: '100%',
      '&:before': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: 48,
        width: '100%',
        backgroundColor: theme.mode === 'dark' ? '#4c4c4c' : '#eaeaea'
      }
    },
    toolBarContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    },
    iconsDetails: {
      display: 'flex',
      width: 200,
      justifyContent: 'space-between'
    },
    bodyTitle: {
      color: 'gray'
    }
  }
)
const PREFIX = 'UnitListUnitStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const UnitListUnitStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  UnitListUnitStyle
}
